module.exports = __webpack_public_path__ + "img/logo-light.3f806e40.png";